export const visit = (vm, at) => {
at({ "pt-br": { "priceComponents": { "pricePerMonth": "{{price}}/m\xEAs", "pricePerMonthPerSeat": "{{price}}/m\xEAs/licen\xE7a", "pricingLabel": "Pre\xE7os de {{name}}", "subtexts": { "startsAt": "A partir de" } } } });
};